// Tier-3 builder presentation seam (Phase 4, mechanical extraction).
//
// The outer page frame shared verbatim by ManualBuilder, ManualBuilderMulti and
// ManualWorkoutEditor. Presentation only: it owns no state, no persistence, no
// validation and no context subscription.
import { DesignV2Scope } from "../../design-v2";

export default function BuilderShell({ children }) {
  return (
    <DesignV2Scope className="lz-builder-shell lz-builder-shell--v2">
      {children}
    </DesignV2Scope>
  );
}
